export default __webpack_public_path__ + "static/media/illust_home_wave.02a16f2c.svg";